// src/api/api.js
import axios from 'axios';
import { toast } from 'react-toastify';

// // Create the Axios instance
// const api = axios.create({
//     baseURL: process.env.REACT_APP_API_BASE_URL, // API base URL
//     headers: { 'Content-Type': 'application/json' }, // Default content type
// });

// // Add a request interceptor to include the token in the headers if available
// api.interceptors.request.use(
//     (config) => {
//         // Retrieve token from localStorage (or any other storage solution)
//         const token = localStorage.getItem('accessToken'); // Replace 'token' with your actual token key
//         console.log("Token in Request:", token);
//         if (token) {
//             // Add the token to Authorization header
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }else {
//             console.log("Token is missing!");
//         }

//         return config; // Always return the config after modification
//     },
//     (error) => {
//         console.error("Interceptor Error:", error);
//         // Handle request error
//         return Promise.reject(error);
//     }
// );


// Optional: Add response interceptors if you want to handle responses globally (like error handling)
// api.interceptors.response.use(
//     (response) => {
//         return response; // Return the response if successful
//     },
//     (error) => {
//         // If the token is expired or unauthorized, handle accordingly
//         if (error.response && error.response.status === 401) {            
//             // Handle unauthorized errors here (e.g., redirect to login page)
//             localStorage.removeItem('accessToken'); // Optionally, clear the token if expired
//             localStorage.removeItem('refreshToken');
//             localStorage.removeItem('linkHash');
//             localStorage.removeItem('USER');
//             window.location.href = '/admin/login';
//             return Promise.reject(error);
//         }
//         const { message, errors } = error.response.data || {};

//         // Display the main message if available
//         if (message) {
//             console.error("API Error:", message);
//         }

//         // Display field-specific errors if available
//         if (errors) {
//             Object.entries(errors).forEach(([field, messages]) => {
//                 messages.forEach((msg) => {
//                     toast.error(`${field}: ${msg}`);
//                 });
//             });
//         }
//         return Promise.reject(error); // Reject the promise if error occurs
//     }
// );

// export default api;

// Create the axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add the interceptor HERE
api.interceptors.request.use(
    (config) => {
        console.log("Interceptor called"); // Debugging
        const token = localStorage.getItem("accessToken");
        console.log("Token from localStorage:", token); // Debugging
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
            console.log("Authorization header added:", config.headers); // Debugging
        } else {
            console.warn("No token found in localStorage!");
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
